export const neutralVariant = {
  root: {
    gap: 0.25,
  },
  list: {
    backgroundColor: 'neutral.900',
    gap: 0.25,
  },
  trigger: {
    borderBottom: '4px solid',
    borderColor: 'neutral.700',
    backgroundColor: 'neutral.700',
    display: 'flex',
    flexDirection: 'column',
    color: 'neutral.300',
    flexGrow: 1,
    _selected: {
      backgroundColor: 'blue.700',
      color: 'neutral.white',
    },
    _hover: {
      backgroundColor: 'neutral.600',
      borderColor: 'neutral.600',
      color: 'neutral.white',
      _selected: {
        backgroundColor: 'blue.700',
      },
    },
    _disabled: {
      backgroundColor: 'neutral.700',
      borderColor: 'neutral.700',
      color: 'neutral.300',
      _hover: {
        backgroundColor: 'neutral.700',
        borderColor: 'neutral.700',
        color: 'neutral.300',
      },
    },
  },
  contentGroup: {
    backgroundColor: 'neutral.850',
  },
  content: {
    backgroundColor: 'transparent',
  },
};
